/* Mullo — interacciones propias (vanilla, sin librerías). */
(function () {
  if (window.__mtInit) return;
  window.__mtInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Reveals al hacer scroll: un solo observer compartido */
  var observer = null;
  function initReveals(root) {
    var els = (root || document).querySelectorAll('.mt-reveal:not(.mt-visible)');
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('mt-visible'); observer.unobserve(e.target); }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { observer.observe(el); });
  }

  /* Héroe (#12): zoom-out de la foto y titular línea a línea */
  function initHero(root) {
    (root || document).querySelectorAll('.mt-hero').forEach(function (el) {
      if (el.dataset.mtInit) return; el.dataset.mtInit = '1';
      requestAnimationFrame(function () { setTimeout(function () { el.classList.add('mt-listo'); }, 80); });
    });
  }

  /* Frase que se ilumina palabra a palabra (#31) */
  var frases = [];
  function pintarFrases() {
    var vh = window.innerHeight;
    frases.forEach(function (f) {
      var r = f.el.getBoundingClientRect();
      var p = (vh * 0.85 - r.top) / (r.height + vh * 0.35);
      p = Math.max(0, Math.min(1, p));
      var n = Math.round(p * f.palabras.length);
      f.palabras.forEach(function (w, i) { w.classList.toggle('mt-on', i < n); });
    });
  }
  function initFrases(root) {
    (root || document).querySelectorAll('[data-mt-frase]').forEach(function (el) {
      if (el.dataset.mtInit) return; el.dataset.mtInit = '1';
      var palabras = Array.prototype.slice.call(el.querySelectorAll('.mt-palabra'));
      if (reduce) { palabras.forEach(function (w) { w.classList.add('mt-on'); }); return; }
      frases = frases.filter(function (f) { return document.body.contains(f.el); });
      frases.push({ el: el, palabras: palabras });
      pintarFrases();
    });
  }
  var pendiente = false;
  window.addEventListener('scroll', function () {
    if (pendiente || !frases.length) return;
    pendiente = true;
    requestAnimationFrame(function () { pendiente = false; pintarFrases(); });
  }, { passive: true });

  /* Hotspots (#17): punto en la foto ⇄ tarjeta de la lista */
  function initPuntos(root) {
    (root || document).querySelectorAll('[data-mt-puntos]').forEach(function (wrap) {
      if (wrap.dataset.mtInit) return; wrap.dataset.mtInit = '1';
      var puntos = wrap.querySelectorAll('.mt-punto');
      var items = wrap.querySelectorAll('.mt-puntos__item');
      function activar(i) {
        puntos.forEach(function (p, j) { p.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
        items.forEach(function (it, j) { it.classList.toggle('mt-activo', j === i); it.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
      }
      puntos.forEach(function (p, i) {
        p.addEventListener('click', function () { activar(i); if (window.innerWidth < 990 && items[i]) items[i].scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'nearest' }); });
        p.addEventListener('mouseenter', function () { activar(i); });
      });
      items.forEach(function (it, i) {
        it.addEventListener('click', function () { activar(i); });
        it.addEventListener('mouseenter', function () { activar(i); });
      });
      activar(0);
    });
  }

  /* Galería arrastrable (#71): arrastrar con el ratón; en táctil ya es nativo */
  function initArrastre(root) {
    (root || document).querySelectorAll('[data-mt-arrastre]').forEach(function (pista) {
      if (pista.dataset.mtInit) return; pista.dataset.mtInit = '1';
      var abajo = false, x0 = 0, s0 = 0, movido = false;
      pista.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        abajo = true; movido = false; x0 = e.clientX; s0 = pista.scrollLeft;
      });
      window.addEventListener('pointermove', function (e) {
        if (!abajo) return;
        var dx = e.clientX - x0;
        if (Math.abs(dx) > 4 && !movido) { movido = true; pista.classList.add('mt-arrastrando'); }
        if (movido) pista.scrollLeft = s0 - dx;
      });
      window.addEventListener('pointerup', function () {
        if (!abajo) return;
        abajo = false;
        pista.classList.remove('mt-arrastrando');
      });
    });
  }

  /* FAQ (#95): cada pregunta abre/cierra la suya */
  function initDudas(root) {
    (root || document).querySelectorAll('.mt-duda').forEach(function (item) {
      if (item.dataset.mtInit) return; item.dataset.mtInit = '1';
      var btn = item.querySelector('.mt-duda__pregunta');
      btn.addEventListener('click', function () {
        var abierto = item.classList.toggle('mt-abierto');
        btn.setAttribute('aria-expanded', abierto ? 'true' : 'false');
      });
    });
  }

  /* Página de producto: galería + variantes + barra de compra móvil */
  function initProducto(root) {
    (root || document).querySelectorAll('[data-mt-producto]').forEach(function (wrap) {
      if (wrap.dataset.mtInit) return; wrap.dataset.mtInit = '1';
      var principal = wrap.querySelector('.mt-galeria__principal img');
      var minis = wrap.querySelectorAll('.mt-galeria__mini');
      function mostrar(src, alt) {
        if (!principal || !src) return;
        principal.style.opacity = '0';
        setTimeout(function () { principal.src = src; principal.alt = alt || ''; principal.style.opacity = '1'; }, 150);
        minis.forEach(function (m) { m.classList.toggle('mt-activa', m.dataset.src === src); });
      }
      minis.forEach(function (m) { m.addEventListener('click', function () { mostrar(m.dataset.src, m.dataset.alt); }); });

      var datos = wrap.querySelector('[data-mt-variantes]');
      var form = wrap.querySelector('form[action*="/cart/add"]');
      var inputId = form ? form.querySelector('input[name="id"]') : null;
      var boton = wrap.querySelector('.mt-compra__boton');
      var precio = wrap.querySelector('[data-mt-precio]');
      var antes = wrap.querySelector('[data-mt-precio-antes]');
      var barraPrecio = document.querySelector('[data-mt-barra-precio]');
      var textoBoton = boton ? boton.dataset.texto : '';
      var textoAgotado = boton ? boton.dataset.agotado : '';
      if (datos && form) {
        var variantes = JSON.parse(datos.textContent);
        var formato = wrap.dataset.moneda || '{{amount_with_comma_separator}} €';
        function dinero(c) {
          var n = (c / 100).toFixed(2);
          return formato.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, n.replace('.', ',')).replace(/\{\{\s*amount\s*\}\}/, n);
        }
        function elegidos() {
          var out = [];
          wrap.querySelectorAll('.mt-compra__opcion').forEach(function (fs) {
            var c = fs.querySelector('input:checked');
            out.push(c ? c.value : null);
          });
          return out;
        }
        function existe(sel) { return variantes.some(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); }); }
        /* Marca como no disponibles las combinaciones que no existen */
        function marcar() {
          var sel = elegidos();
          wrap.querySelectorAll('.mt-compra__opcion').forEach(function (fs, i) {
            fs.querySelectorAll('input').forEach(function (inp) {
              var prueba = sel.slice(); prueba[i] = inp.value;
              var lbl = inp.nextElementSibling;
              if (lbl) lbl.style.opacity = existe(prueba) ? '' : '.35';
            });
          });
        }
        wrap.querySelectorAll('.mt-compra__valores input').forEach(function (inp) {
          inp.addEventListener('change', function () {
            var sel = elegidos();
            var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
            if (!v) {
              /* Si la combinación no existe, busca la primera que respete la opción tocada */
              var fsIndex = Array.prototype.indexOf.call(wrap.querySelectorAll('.mt-compra__opcion'), inp.closest('.mt-compra__opcion'));
              v = variantes.find(function (x) { return x.available && x.options[fsIndex] === inp.value; }) || variantes.find(function (x) { return x.options[fsIndex] === inp.value; });
              if (!v) return;
              wrap.querySelectorAll('.mt-compra__opcion').forEach(function (fs, i) {
                fs.querySelectorAll('input').forEach(function (o) { o.checked = o.value === v.options[i]; });
              });
            }
            wrap.querySelectorAll('.mt-compra__opcion').forEach(function (fs) {
              var c = fs.querySelector('input:checked');
              var etiqueta = fs.querySelector('legend span');
              if (etiqueta && c) etiqueta.textContent = c.dataset.etiqueta || c.value;
            });
            inputId.value = v.id;
            if (precio) precio.textContent = dinero(v.price);
            if (barraPrecio) barraPrecio.textContent = dinero(v.price);
            if (antes) { antes.textContent = v.compare_at_price > v.price ? dinero(v.compare_at_price) : ''; }
            if (boton) { boton.disabled = !v.available; boton.querySelector('span').textContent = v.available ? textoBoton : textoAgotado; }
            if (v.featured_image) mostrar(v.featured_image, v.name);
            marcar();
            if (window.history && window.history.replaceState) {
              var url = new URL(window.location.href); url.searchParams.set('variant', v.id); window.history.replaceState({}, '', url.toString());
            }
          });
        });
        marcar();
      }

      var barra = document.querySelector('.mt-barra-compra');
      if (barra && boton && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          barra.classList.toggle('mt-visible', !entries[0].isIntersecting);
        });
        io.observe(boton);
        var irBoton = barra.querySelector('[data-mt-ir-comprar]');
        if (irBoton) irBoton.addEventListener('click', function () { boton.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); });
      }
    });
  }

  function initTodo(e) {
    var root = e && e.target && e.target.querySelectorAll ? e.target : document;
    initReveals(root); initHero(root); initFrases(root); initPuntos(root);
    initArrastre(root); initDudas(root); initProducto(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTodo);
  else initTodo();
  document.addEventListener('shopify:section:load', initTodo);
})();
